import { B2bItem } from 'components/Blocks/Product/CategoryPromotedProducts/Item/B2bItem';
import { B2cItem } from 'components/Blocks/Product/CategoryPromotedProducts/Item/B2cItem';
import { WebItem } from 'components/Blocks/Product/CategoryPromotedProducts/Item/WebItem';
import Button from 'components/Forms/Button/Button';
import { isB2bDomain, isB2cDomain } from 'helpers/isDomainLocale';
import { useGtmProductListView } from 'hooks/gtm/useGtmProductListView';
import { useComponentUpdate } from 'hooks/helpers/UseComponentUpdate';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useRouter } from 'next/router';
import { ArrowIcon, ArrowUpIcon } from 'public/svg/IconsSvg';
import { useState } from 'react';
import { GtmListNameType } from 'types/gtm';
import { SliderProductItemType } from 'types/product';

const NUMBER_OF_VISIBLE_ITEMS = 3;

type ProductsListProps = {
    products: SliderProductItemType[];
    gtmListName: GtmListNameType;
};

export const ProductsList: FC<ProductsListProps> = ({ products, gtmListName }) => {
    const domainConfig = useDomainConfig();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const t = useTypedTranslationFunction();
    const router = useRouter();

    useGtmProductListView(products, gtmListName);

    useComponentUpdate(() => setIsCollapsed(false), [router.asPath]);

    return (
        <>
            {products.map((item, index) => {
                return index <= NUMBER_OF_VISIBLE_ITEMS - 1 || isCollapsed ? (
                    isB2cDomain(domainConfig) ? (
                        <B2cItem key={item.uuid} item={item} gtmListName={gtmListName} listIndex={index} />
                    ) : isB2bDomain(domainConfig) ? (
                        <B2bItem key={item.uuid} item={item} gtmListName={gtmListName} listIndex={index} />
                    ) : (
                        <WebItem key={item.uuid} item={item} gtmListName={gtmListName} listIndex={index} />
                    )
                ) : null;
            })}
            {products.length > NUMBER_OF_VISIBLE_ITEMS && (
                <div className="mt-5 text-center">
                    <Button type="button" size="small" onClick={() => setIsCollapsed((prev) => !prev)}>
                        {isCollapsed ? (
                            <>
                                <ArrowUpIcon className="!mr-2 h-2.5 w-2.5" />
                                <span>
                                    {t('Hide the next {{ count }} best sellers', {
                                        count: products.length - NUMBER_OF_VISIBLE_ITEMS,
                                    })}
                                </span>
                            </>
                        ) : (
                            <>
                                <ArrowIcon className="!mr-2 h-2.5 w-2.5" />
                                <span>
                                    {t('View the next {{ count }} best sellers', {
                                        count: products.length - NUMBER_OF_VISIBLE_ITEMS,
                                    })}
                                </span>
                            </>
                        )}
                    </Button>
                </div>
            )}
        </>
    );
};
